var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	18535: {
		fallback: () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(13667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.2.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	21055: {
		fallback: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(21036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.9.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	},
	45675: {
		fallback: () => (__webpack_require__.e(957).then(() => (() => (__webpack_require__(52957))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.25",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	59890: {
		fallback: () => (__webpack_require__.e(947).then(() => (() => (__webpack_require__(28947))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.16.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	73834: {
		fallback: () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(31021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	90837: {
		fallback: () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(82124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	93676: {
		fallback: () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(325)]).then(() => (() => (__webpack_require__(75220))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.1.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	13325: {
		fallback: () => (__webpack_require__.e(957).then(() => (() => (__webpack_require__(52957))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	74125: {
		fallback: () => (__webpack_require__.e(957).then(() => (() => (__webpack_require__(52957))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	94626: {
		fallback: () => (__webpack_require__.e(579).then(() => (() => (__webpack_require__(95579))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^2.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "http-status-codes",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"125": [
		74125
	],
	"236": [
		18535,
		21055,
		45675,
		59890,
		73834,
		90837,
		93676
	],
	"325": [
		13325
	],
	"440": [
		94626
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}